import React from "react";
import { trustBadges } from "../../data/home";
import { TrustBadge } from "../brand/TrustBadge";
export function TrustMarquee() {
  return <section aria-label="Credentials" className="border-y border-gold/25 bg-sand" data-id="element-290" data-mp="2y089q54pq2ge">
      {/* Mobile / tablet: static grid */}
      <ul className="gutter grid grid-cols-2 gap-x-6 gap-y-6 py-10 sm:grid-cols-3 lg:hidden" data-id="element-291" data-mp="3716g2u2mim25">
        {trustBadges.map(b => <li key={b.key} data-id="element-292" data-mp="2jatzyvx85j0h">
            <TrustBadge badgeKey={b.key} label={b.label} data-id="element-293" data-mp="2jc51ep376eof" />
          </li>)}
      </ul>

      {/* Desktop: slow seamless marquee, pauses on hover */}
      <div className="marquee relative hidden overflow-hidden py-8 lg:block" data-id="element-294" data-mp="2t1568p4ds4aj">
        <div className="marquee-track flex w-max" data-id="element-295" data-mp="2t3805k8nmhkj">
          {[0, 1].map(copy => <ul key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1} data-id="element-296" data-mp="2o8lsns5p195q">
              {trustBadges.map(b => <li key={`${copy}-${b.key}`} className="flex items-center" data-id="element-297" data-mp="1vmj5qbm1ahl6">
                  <span className="px-[clamp(2rem,3vw,4rem)]" data-id="element-298" data-mp="11bc95kcx0c8y">
                    <TrustBadge badgeKey={b.key} label={b.label} data-id="element-299" data-mp="11aszss1byw6j" />
                  </span>
                  <span className="h-8 w-px bg-gold/40" aria-hidden="true" data-id="element-300" data-mp="16948v0jsx2np" />
                </li>)}
            </ul>)}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-[linear-gradient(90deg,#F5F1EA,rgba(245,241,234,0))]" aria-hidden="true" data-id="element-301" data-mp="1f2hb4t3r9gmg" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-[linear-gradient(270deg,#F5F1EA,rgba(245,241,234,0))]" aria-hidden="true" data-id="element-302" data-mp="ie1d08mkxyxq" />
      </div>
    </section>;
}